import { render, staticRenderFns } from "./AccessTypeButton.vue?vue&type=template&id=ff04671e"
import script from "./AccessTypeButton.vue?vue&type=script&lang=ts"
export * from "./AccessTypeButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports